import React from 'react';
import {Link} from 'react-router-dom';


var NavBar = props => {
  //<!-- Navigation -->
  return (
    <nav className="navbar navbar-default navbar-expand-sm fixed-top navigation">
      <div className="container">
        {
          //<a className="navbar-brand" href="index.html">Walter M. Cunningham Education Foundation</a>
        }
        <button className="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
          Menu
          <i className="fa fa-bars"></i>
        </button>
        <div className="collapse navbar-collapse" id="navbarResponsive">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item">
              <Link className="nav-link" to="/">Home</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/donate">Donate</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/scholarship">Scholarship</Link>
            </li>
            {
              //<li className="nav-item">
            //  <a className="nav-link" href="contact.html">Contact</a>
            //</li>
            }
          </ul>
        </div>
      </div>
    </nav>
  )
};

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/NavBar.js